<script setup lang="ts">
import { Collapse } from "vue-collapsed";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faChevronRight } from "@fas/faChevronRight";import { faSignOutAlt } from "@fas/faSignOutAlt";import { faShoppingCart } from "@fas/faShoppingCart";import { faSearch } from "@fas/faSearch";import { faChevronDown } from "@fas/faChevronDown";import { faTimes } from "@fas/faTimes";import { faPlusCircle } from "@fas/faPlusCircle";import { faUserCircle } from "@fas/faUserCircle";









import { faSpinnerThird } from "@fad/faSpinnerThird";
import { faHeart } from "@far/faHeart";
import { faBars } from "@fal/faBars";import { faChevronLeft } from "@fal/faChevronLeft";import { faChevronRight as falChevronRight } from "@fal/faChevronRight";import { faAlbumCollection } from "@fal/faAlbumCollection";
import { ref, inject, nextTick, onMounted, onBeforeUnmount, computed, watch } from "vue";
import { getStyles } from "@/Composables/styles";
import { layoutStructure } from "@/Composables/useLayoutStructure";
import { debounce, get } from "lodash-es";
import { ctrans } from "@/Composables/useTrans";
import LinkIris from "@/Iris/Components/LinkIris.vue";
import { menuCategoriesToMenuStructure, MenuSidebarSource } from "@/Composables/Iris/useMenu"
import LoadingIcon from "@/Components/Utils/LoadingIcon.vue"
import Image from "@common/Components/Image.vue";

library.add(
    faChevronLeft,
    falChevronRight, faAlbumCollection,
    faChevronRight,
    faSignOutAlt,
    faShoppingCart,
    faHeart,
    faSearch,
    faChevronDown,
    faTimes,
    faPlusCircle,
    faBars,
    faUserCircle,
    faSpinnerThird
);

const props = defineProps<{
    fieldValue: {
        navigation?: any[]
        setting_on_sidebar?: {
            is_follow?: boolean
        }
        custom_navigation_1_styling?: {
            index_of_navigation_to_apply?: string
            properties?: {}
        }
        [key: string]: any
    };
    screenType?: "mobile" | "tablet" | "desktop";
    sidebar?: MenuSidebarSource;
}>();

const layout = inject("layout", layoutStructure);
const isCollapsedOpen = ref(false);
const hoveredNavigation = ref<any>(null);
const loadingItem = ref<string | null>(null);

const debSetCollapsedTrue = debounce(() => (isCollapsedOpen.value = true), 500);
const debSetCollapsedFalse = debounce(() => (isCollapsedOpen.value = false), 500);

const onMouseEnterMenu = (navigation: any) => {
    debSetCollapsedTrue();
    hoveredNavigation.value = navigation;
};

const onClickSubnav = (link: any) => {
    if (!link?.link?.href) return;
    loadingItem.value = link.id || link.label;
};

const onStartNavigation = (navigation: any) => {
    if (!navigation?.link?.href) return;
    loadingItem.value = navigation.id || navigation.label;
}

const _scrollContainer = ref<HTMLElement | null>(null);
const isAbleScrollToRight = ref(false);
const isAbleScrollToLeft = ref(false);

const checkScroll = () => {
    const el = _scrollContainer.value;
    if (!el) return;
    isAbleScrollToLeft.value = el.scrollLeft > 0;
    isAbleScrollToRight.value =
        parseInt(el.scrollLeft.toString()) + 1 + el.clientWidth < el.scrollWidth;
};

const scrollRight = () => _scrollContainer.value?.scrollBy({ left: 200, behavior: "smooth" });
const scrollLeft = () => _scrollContainer.value?.scrollBy({ left: -200, behavior: "smooth" });

onMounted(() => {
    nextTick(() => {
        checkScroll();
        window.addEventListener("resize", checkScroll);
    });
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", checkScroll);
});

const isOpenMenuMobile = inject("isOpenMenuMobile", ref(true));

const hasNavigationIcon = (navigation: any) => navigation.type === "multiple" || !!navigation.icon;

const irisSidebarSource = computed<MenuSidebarSource>(() => {
    const irisSidebar = layout.iris?.sidebar

    return {
        navigation: irisSidebar?.data?.fieldValue?.navigation ?? [],
        navigation_bottom: irisSidebar?.data?.fieldValue?.navigation_bottom ?? [],
        product_categories: irisSidebar?.product_categories ?? [],
    }
})

const sidebarSource = computed<MenuSidebarSource>(() => props.sidebar ?? irisSidebarSource.value)

const isFollowSidebar = computed(() => get(props, "fieldValue.setting_on_sidebar.is_follow", false))

const compCustomTopNavigation = computed(() => isFollowSidebar.value ? sidebarSource.value.navigation : null)

const compCustomBottomNavigation = computed(() => isFollowSidebar.value ? sidebarSource.value.navigation_bottom : null)

const selectedMenu = computed(() => {
    if (isFollowSidebar.value) {
        return menuCategoriesToMenuStructure(sidebarSource.value.product_categories) || []
    }

    return (props.fieldValue?.navigation ?? []).filter((item) => !item.hidden)
})

const navHoverClass = computed(() => getStyles(props.fieldValue?.hover?.container?.properties, props.screenType, false))

const internalHref = (url: string) => {
    if (!url) return '';

    return url.replace(/^(https?:\/\/)?(www\.)?[^/]+/, "")
}

const compIndexStyling1 = computed(() => {
    const indexesToApply = props.fieldValue?.custom_navigation_1_styling?.index_of_navigation_to_apply

    return typeof indexesToApply === 'string'
        ? indexesToApply.split(',').map(s => Number(s.trim())).filter(n => !isNaN(n))
        : []
})

watch(loadingItem, (newVal) => {
    if (!newVal) {
        isCollapsedOpen.value = false
        debSetCollapsedTrue.cancel()
    }
})

const getSubnavIndex = (col: number) => {
    const imgPos = hoveredNavigation.value?.image_position
    const hasImage = !!hoveredNavigation.value?.image

    if (!hasImage) return col - 1

    if (col === imgPos) return -1

    if (col > imgPos) return col - 2

    return col - 1
}

const imageCol = computed(() => {
    if (!hoveredNavigation.value?.image) return null

    const pos = Number(hoveredNavigation.value?.image_position)
    if (pos >= 1 && pos <= 4) return pos

    return 4
})

const subnavColumns = computed(() => {
    const subnavs = hoveredNavigation.value?.subnavs || []
    const colCount = hoveredNavigation.value?.image ? 3 : 4
    const perCol = Math.ceil(subnavs.length / colCount) || 1
    return Array.from({ length: colCount }, (_, i) => subnavs.slice(i * perCol, (i + 1) * perCol))
})
</script>

<template>
    <div class="bg-white py-1 border-b border-0.5 border-gray-300" :style="{
        ...getStyles(layout?.app?.webpage_layout?.container?.properties, screenType),
        margin: 0,
        padding: 0,
        ...getStyles(fieldValue?.container?.properties, screenType),
    }">
        <div @mouseleave="() => (debSetCollapsedFalse(), debSetCollapsedTrue.cancel())"
            @mouseenter="() => (debSetCollapsedTrue(), debSetCollapsedFalse.cancel())"
            :style="getStyles(fieldValue?.navigation_container?.properties, screenType)"
            class="relative flex justify-between items-center gap-x-2 px-4">

            <!-- Button: All categories -->
            <div v-if="layout.retina?.type !== 'fulfilment'" class="relative"
                @mouseenter="() => (debSetCollapsedFalse(), debSetCollapsedTrue.cancel())">
                <div @click="() => { isOpenMenuMobile = true }"
                    class="flex items-center gap-x-2 h-fit px-5 py-1 text-sm rounded-full hover:bg-gray-400/20 w-fit cursor-pointer whitespace-nowrap"
                    :style="{
                        border: `solid 1px ${fieldValue?.navigation_container?.properties?.text?.color || 'currentColor'}`,
                        color: fieldValue?.navigation_container?.properties?.text?.color
                    }">
                    <FontAwesomeIcon icon="fal fa-bars" class="opacity-80 text-[10px]" fixed-width aria-hidden="true" />
                    <span class="font-medium">{{ ctrans("All Categories") }}</span>
                </div>
                <Transition>
                    <div v-if="isAbleScrollToLeft" class="absolute -right-24 z-10 top-0 h-full w-24 pointer-events-none"
                        :style="{
                            background: `linear-gradient(to right, ${layout?.app?.webpage_layout?.container?.properties?.background?.color ?? '#fff'} 0%, ${layout?.app?.webpage_layout?.container?.properties?.background?.color ?? '#fff'} 45%, transparent 100%)`
                        }" />
                </Transition>

                <Transition>
                    <div v-if="isAbleScrollToLeft" @click="() => scrollLeft()"
                        class="w-6 h-6 z-10 bg-gray-500 hover:bg-gray-700 text-white rounded-full flex items-center justify-center absolute -right-10 top-1/2 -translate-y-1/2 cursor-pointer text-inherit">
                        <FontAwesomeIcon icon="fal fa-chevron-left" fixed-width aria-hidden="true" class="text-[8px]" />
                    </div>
                </Transition>
            </div>

            <!-- Scroll Gradient + Arrows -->
            <Transition>
                <div v-if="isAbleScrollToRight" class="absolute right-4 z-10 top-0 h-full w-24 pointer-events-none"
                    :style="{
                        background: `linear-gradient(to left, ${layout?.app?.webpage_layout?.container?.properties?.background?.color ?? '#fff'} 0%, ${layout?.app?.webpage_layout?.container?.properties?.background?.color ?? '#fff'} 35%, transparent 100%)`
                    }" />
            </Transition>
            <Transition>
                <div v-if="isAbleScrollToRight" @click="scrollRight"
                    class="w-6 h-6 z-10 bg-gray-500 hover:bg-gray-700 text-white rounded-full flex items-center justify-center absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer">
                    <FontAwesomeIcon icon="fal fa-chevron-left" rotation="180" fixed-width class="text-[8px]" />
                </div>
            </Transition>

            <!-- Section: list menu Navigation -->
            <nav ref="_scrollContainer" @scroll="checkScroll"
                class="relative flex text-sm text-gray-600 w-full overflow-x-auto scrollbar-hide ml-5">
                <!-- Navigation: Custom Top (if follow sidebar) -->
                <template v-for="(navigation, idxNavigation) in compCustomTopNavigation" :key="idxNavigation">
                    <component :is="navigation?.link?.href ? LinkIris : 'div'"
                        @mouseenter="() => onMouseEnterMenu(navigation)" :type="navigation?.link?.type"
                        @start="() => onStartNavigation(navigation)" @finish="() => loadingItem = null"
                        :id="navigation?.link?.id"
                        :style="compIndexStyling1?.includes(idxNavigation + 1) ? getStyles(fieldValue?.custom_navigation_1_styling?.properties, screenType) : getStyles(fieldValue?.navigation_container?.properties, screenType)"
                        :href="navigation?.link?.href" :canonical_url="navigation?.link?.canonical_url"
                        class="group relative w-full  py-2 px-6 flex items-center justify-center transition duration-200" :class="hoveredNavigation?.id === navigation.id && isCollapsedOpen
                            ? 'navigation'
                            : navigation?.link?.href
                                ? 'cursor-pointer navigation'
                                : ''">
                        <span class="text-center whitespace-nowrap">{{ navigation.label }}</span>
                        <div v-if="hasNavigationIcon(navigation)">
                            <LoadingIcon v-if="loadingItem === (navigation.id || navigation.label)" class="ml-2 text-[8px]" />
                            <FontAwesomeIcon v-else-if="navigation.type === 'multiple'" icon="fas fa-chevron-down"
                                class="ml-2 text-[8px]" fixed-width />
                            <FontAwesomeIcon v-else :icon="navigation.icon" class="ml-2 text-[8px]" fixed-width />
                        </div>
                        <span v-else-if="loadingItem === (navigation.id || navigation.label)"
                                class="absolute right-2 top-1/2 -translate-y-1/2 text-[8px]">
                            <LoadingIcon />
                        </span>
                    </component>
                </template>

                <!-- Navigation: main -->
                <template v-for="(navigation, idxNavigation) in selectedMenu" :key="idxNavigation">
                    <component :is="navigation?.link?.href ? LinkIris : 'div'"
                        @mouseenter="() => onMouseEnterMenu(navigation)" :type="navigation?.link?.type"
                        @start="() => onStartNavigation(navigation)" @finish="() => loadingItem = null"
                        :style="compIndexStyling1?.includes(idxNavigation + 1 + (compCustomTopNavigation?.length ?? 0)) ? getStyles(fieldValue?.custom_navigation_1_styling?.properties, screenType) : getStyles(fieldValue?.navigation_container?.properties, screenType)"
                        :href="navigation?.link?.href" :id="navigation?.link?.id"
                        :canonical_url="navigation?.link?.canonical_url"
                        class="group relative w-full py-2 px-6 flex items-center justify-center transition duration-200" :class="hoveredNavigation?.id === navigation.id && isCollapsedOpen
                            ? 'navigation underline'
                            : navigation?.link?.href
                                ? 'cursor-pointer navigation'
                                : ''">
                        <span class="text-center whitespace-nowrap">{{ navigation.label }}</span>
                        <div v-if="hasNavigationIcon(navigation)" class="ml-2">
                            <LoadingIcon v-if="loadingItem === (navigation.id || navigation.label)" class="text-[8px] align-middle" />
                            <FontAwesomeIcon v-else-if="navigation.type === 'multiple'" icon="fas fa-chevron-down"
                                class="text-[8px] align-middle" fixed-width />
                            <FontAwesomeIcon v-else :icon="navigation.icon"
                                class="text-[8px] align-middle" fixed-width />
                        </div>
                        <span v-else-if="loadingItem === (navigation.id || navigation.label)"
                                class="absolute right-2 top-1/2 -translate-y-1/2 text-[8px] align-middle">
                            <LoadingIcon />
                        </span>
                    </component>
                </template>

                <!-- Navigation: Custom Bottom (if follow sidebar) -->
                <template v-for="(navigation, idxNavigation) in compCustomBottomNavigation" :key="idxNavigation">
                    <component :is="navigation?.link?.href ? LinkIris : 'div'"
                        @mouseenter="() => onMouseEnterMenu(navigation)" :type="navigation?.link?.type"
                        @start="() => onStartNavigation(navigation)" @finish="() => loadingItem = null"
                        :id="navigation?.link?.id"
                        xstyle="getStyles(fieldValue?.custom_navigation_styling?.custom_bottom?.properties, screenType)"
                        :style="compIndexStyling1?.includes(idxNavigation + 1 + (compCustomTopNavigation?.length ?? 0) + (selectedMenu?.length ?? 0)) ? getStyles(fieldValue?.custom_navigation_1_styling?.properties, screenType) : getStyles(fieldValue?.navigation_container?.properties, screenType)"
                        :href="navigation?.link?.href" :canonical_url="navigation?.link?.canonical_url"
                        class="group relative w-full  py-2 px-6 flex items-center justify-center transition duration-200" :class="hoveredNavigation?.id === navigation.id && isCollapsedOpen
                            ? 'navigation'
                            : navigation?.link?.href
                                ? 'cursor-pointer navigation'
                                : ''">
                        <span class="text-center whitespace-nowrap">{{ navigation.label }}</span>
                        <div v-if="hasNavigationIcon(navigation)">
                            <LoadingIcon v-if="loadingItem === (navigation.id || navigation.label)" class="ml-2 text-[8px]" />
                            <FontAwesomeIcon v-else-if="navigation.type === 'multiple'" icon="fas fa-chevron-down"
                                class="ml-2 text-[8px]" fixed-width />
                            <FontAwesomeIcon v-else :icon="navigation.icon" class="ml-2 text-[8px]" fixed-width />
                        </div>
                        <span v-else-if="loadingItem === (navigation.id || navigation.label)" class="absolute right-2 top-1/2 -translate-y-1/2 text-[8px]">
                            <LoadingIcon />
                        </span>
                    </component>
                </template>
            </nav>

            <!-- Drawer: Sub Navigation -->
            <Collapse v-if="hoveredNavigation?.subnavs && hoveredNavigation.type === 'multiple'" :when="isCollapsedOpen"
                as="div" class="z-[49] absolute left-0 top-full bg-white border-t w-full shadow-lg"
                :style="getStyles(fieldValue?.container?.properties, screenType)">
                <div class="grid grid-cols-4 gap-8 p-6 items-start">

                    <template v-for="col in 4" :key="col">

                        <!-- IMAGE COLUMN -->
                        <div v-if="hoveredNavigation?.image && imageCol === col" class="w-full">
                            <div class="w-full overflow-hidden rounded-lg bg-gray-50">
                                <Image :src="hoveredNavigation.image" class="w-full h-full object-cover" />
                            </div>
                        </div>

                        <div v-else>
                            <template
                                v-if="getSubnavIndex(col) >= 0 && subnavColumns[getSubnavIndex(col)]?.length">
                                <div class="space-y-6">
                                    <div
                                        v-for="(subnav, idxSub) in subnavColumns[getSubnavIndex(col)]"
                                        :key="subnav.id || subnav.title">
                                        <!-- TITLE -->
                                        <component :is="subnav?.link?.href ? LinkIris : 'div'"
                                            :href="internalHref(subnav?.link?.href)" :type="subnav?.link?.type"
                                            :target="subnav?.link?.target" :canonical_url="subnav?.link?.canonical_url"
                                            :id="subnav?.link?.id" :style="{
                                                ...getStyles(layout?.app?.webpage_layout?.container?.properties, screenType),
                                                margin: 0,
                                                background: 'transparent',
                                                padding: 0,
                                                fontWeight: 600,
                                                ...getStyles(fieldValue?.sub_navigation?.properties, screenType)
                                            }" class="relative font-semibold text-gray-700 flex items-center gap-x-3"
                                            @start="() => onClickSubnav(subnav)" @finish="() => loadingItem = null">
                                            <div class="relative">
                                                {{ subnav.title }}
                                                <div class="top-1/2 -translate-y-1/2 absolute -left-6">
                                                    <LoadingIcon v-if="loadingItem === (subnav.id || subnav.label)" />
                                                    <FontAwesomeIcon v-else-if="subnav.icon" :icon="subnav.icon"
                                                        fixed-width class="text-[10px] text-gray-400" />
                                                </div>
                                            </div>
                                        </component>

                                        <!-- LINKS -->
                                        <div v-for="(linkData, idxFam) in subnav?.links" :key="linkData.id" :style="{
                                            ...getStyles(fieldValue?.sub_navigation_link?.properties, screenType)
                                        }">
                                            <LinkIris v-if="linkData.link?.href" :id="linkData.id"
                                                :href="internalHref(linkData.link.href)"
                                                :canonical_url="linkData.link.canonical_url" :type="linkData.link.type"
                                                @start="() => loadingItem = `${subnav.id || subnav.title}_${idxFam}`"
                                                @finish="() => loadingItem = null">
                                                <template #default>
                                                    <div class="py-1 relative">
                                                        <div class="top-1/2 -translate-y-1/2 absolute -left-6">
                                                            <LoadingIcon v-if="loadingItem == `${subnav.id || subnav.title}_${idxFam}`" />
                                                        </div>
                                                        {{ linkData.label }}
                                                    </div>
                                                </template>
                                            </LinkIris>

                                            <div v-else class="py-1">
                                                {{ linkData.label }}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </template>
                        </div>

                    </template>

                </div>
            </Collapse>
        </div>
    </div>
</template>

<style scoped lang="scss">
.container {
    max-width: 1980px;
}

.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.editor-class a {
    font-weight: 400;
}

.sub-nav-title {
    .editor-class a {
        font-weight: 600;
    }
}


.navigation {
    transition-duration: v-bind('`${props.fieldValue?.hover?.container?.properties?.transition?.duration || 0}ms`') !important;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        background: v-bind('navHoverClass?.background || null') !important;
        color: v-bind('navHoverClass?.color || null') !important;
        font-family: v-bind('navHoverClass?.fontFamily || null') !important;
        font-size: v-bind('navHoverClass?.fontSize || null') !important;
        font-style: v-bind('navHoverClass?.fontStyle || null') !important;
        ;
    }
}
</style>
